import { render } from "./VeteranList.vue?vue&type=template&id=628b36b8"
import script from "./VeteranList.vue?vue&type=script&lang=js"
export * from "./VeteranList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__